import PlanningGuideCard from "components/PlanningGuideCard";
import ScreenChrome from "components/ScreenChrome";

import { OTHER_OPTIONS_COPY } from "../copy";

/** Where a pre-need visitor in an area we do not serve ends up. */
export default function OtherOptionsStep() {
  return (
    <ScreenChrome
      kicker={OTHER_OPTIONS_COPY.kicker}
      titleSize="compact"
      titleA={OTHER_OPTIONS_COPY.titleA}
      titleB={OTHER_OPTIONS_COPY.titleB}
      blurb={OTHER_OPTIONS_COPY.blurb}
    >
      <div className="mt-8 flex max-w-[620px] flex-col gap-4">
        <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-oat-700">
          What we can do now
        </p>
        <PlanningGuideCard />
        <p className="px-1 text-base leading-[1.55] text-oat-700">
          {OTHER_OPTIONS_COPY.note}
        </p>
      </div>
    </ScreenChrome>
  );
}
